import { render, staticRenderFns } from "./userAccessDrawer.vue?vue&type=template&id=77bdd534&scoped=true"
import script from "./userAccessDrawer.vue?vue&type=script&lang=js"
export * from "./userAccessDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77bdd534",
  null
  
)

export default component.exports